/* eslint-disable */
const printByNet = async (content, printerName) => {
    const EXTENSION_ID = "idkpcgloigdlkbbpagmhiimddfhgbmml";

    return new Promise((resolve, reject) => {
        if (!window.chrome || !window.chrome.runtime) {
            return reject(new Error("La extensión no está disponible"));
        }

        chrome.runtime.sendMessage(
            EXTENSION_ID,
            { type: "network", ip:printerName.ip, content },
            (response) => {
                if (chrome.runtime.lastError) {
                    return reject(new Error(chrome.runtime.lastError.message));
                }

                if (!response || response.status !== "ok") {
                    const errorMessage = response?.message || "Error desconocido al imprimir";
                    return reject(new Error(errorMessage));
                }

                resolve(true);
            }
        );
    });

};

export { printByNet };